const CreditStatus = Object.freeze({
    CERRADO: 10,
    DISPERSION_PENDIENTE: 20,
    ETAPA_1: 30,
    ETAPA_2: 40,
    ETAPA_3: 50
})

module.exports = CreditStatus
